import { render } from "./NewLogin.vue?vue&type=template&id=01c43da2&scoped=true"
import script from "./NewLogin.vue?vue&type=script&lang=js"
export * from "./NewLogin.vue?vue&type=script&lang=js"

import "./NewLogin.vue?vue&type=style&index=0&id=01c43da2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c43da2"]])

export default __exports__